"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useHtmlElementEventListener = void 0;
var react_1 = require("react");
var use_stable_handler_1 = require("./use-stable-handler");
var useHtmlElementEventListener = function (element, type, listener) {
    var stableListener = (0, use_stable_handler_1.useStableHandler)(listener);
    (0, react_1.useEffect)(function () {
        if (element) {
            element.addEventListener(type, stableListener);
            return function () { return element.removeEventListener(type, stableListener); };
        }
        return function () { };
    }, [element, stableListener, type]);
};
exports.useHtmlElementEventListener = useHtmlElementEventListener;
